import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import {
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';
import { Button, Modal } from 'react-bootstrap';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [getPdf, setPdf] = useState('');

	useEffect(() => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			requestNumber: GetLocal('RequestNumber')
		};
		EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowCorrespondenceReview", inputValue, ShowServiceResultSuccess);
	}, []);

	const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
	}

	const PrintAction = (row) => {
		var inputValue = {
			session: GetLocal('EmployeeSession'),
			letterNumber: row.LetterNumber
		};
		FetchService("Employee/Urbanization/Request/ShowCorrespondence ", inputValue, GetLetterSuccess, GetRequestsReviewFail);
	}

	const GetLetterSuccess = (ServiceResult) => {
		setPdf("data:application/pdf;base64," + ServiceResult);
		setShowModal(true)
	}

	const GetRequestsReviewFail = (ServiceResult) => {
		setShowModal(false)
	}

	return (
		<div>
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')} />
			<ShowFilesReviewAbstractList />
			{getServiceResult ? <div>
				<GridControl
					data={Object.keys(getServiceResult).length > 0 && getServiceResult.CorrespondenceInfoList}
					customHeaders={{
						"LetterTitle": "نوع نامه",
						"LetterNumber": "شماره نامه",
						"LetterDate": "تاریخ نامه",
						"RequestLetterNumber": "شماره نامه پاسخ",
						"RequestLetterDate": "تاریخ نامه پاسخ",
						"RegistrationLetterNumber": "شماره ثبت پاسخ",
						"RegistrationLetterDate": "تاریخ ثبت پاسخ",
						"Description": "توضیحات",
						"PrintAction": "چاپ"
					}}
					PrintAction={PrintAction}
				/>
				<br />
				<GridControl
					data={Object.keys(getServiceResult).length > 0 && getServiceResult.DocumentActionInfoList}
					customHeaders={{
						"ActionIdentifierTitle": "نوع نامه",
						"User": "نام کابر",
						"ActionDate": "زمان قدیم",
						"ActionTitle": "نحوه اقدام",
						"SerialNumber": "شماره نامه",
						"DocumentTitle": "آخرین اقدام پروانه"
					}}
				/>
				<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
					<Modal.Header closeButton>
						<Modal.Title></Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="danger" onClick={() => setShowModal(false)}>
							بستن
						</Button>
					</Modal.Footer>
				</Modal>
			</div>
				:
				<div className="alert alert-danger text-center">موردی یافت نشد.</div>
			}
		</div>
	);
}
